import {BasicSelect,MultiSelect} from 'vue-search-select';
import CryptoJS from 'crypto-js';
import Pagination from './../../../../shared/components/pagination';
import CustomExpandableTable from '../../../../shared/components/customExpandableTable';
import Loader from '../../../../shared/components/loader';
import CONSTANT from './../../../../shared/constants/constant';
import Util from './../../../../shared/util/util';
import Treeselect from '@riophae/vue-treeselect';
import createFTCHubCashDeposit from './../createFTCHubCashDeposit';
import FTCservices from './../../../../firstAndLastmilemanagement/services/firstAndLastmilemanagement.service'
import XLSX from 'xlsx';
const moment = require('moment');
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';


export default {
  name: 'FTCCashDepositList',
  components: {
    Treeselect,
    CryptoJS,
    Pagination,
    BasicSelect,
    CustomExpandableTable,
    Loader,
    createFTCHubCashDeposit,
    FTCservices,
    depositSlipImageDownload:'',
    showImgDownloadBtn: false,
    Multiselect
  },
  data: function() {
    return {
  createFTCCashDeposit:false,
  viewDepositSlip:false,
  isLoading:false,
  innerTableColumn: ['Assigned Territory'],
  tableColumn: ['WayBill No','Cash Deposit ID','Amount deposited(INR)','Deposit Slip Number','Deposit Date','Created Date','Deposit by','Deposit Status','Action'],
  tableItems: [],
  depositStatuslist:[
    { id:'0', label:'To be verified'},
    { id:'1', label:'Accepted'},
    { id:'2', label:'Rejected'},
  ],
  depositStatus:null,
  viewTransactionList:[
    { id:1, label:'1'},
    { id:2, label:'2'},
    { id:3, label:'3'},
    { id:4, label:'4'},
    { id:5, label:'5'},
  ],
  viewtransaction:null,
  depositSlipNumber: "",
  cashDepositID: "",
  totalPage: 0,
  cashDepositIDSHow:'',
  currentPage: 1,
  totalCount: 0,
  perPage: 0,
  pageLimit: CONSTANT.PER_PAGE_DATA,
  offset: 0,
  depositToDate: null,
  depositFromDate: null,
  companyName: "",
  AWB: "",
  defaultHubID:'',
  showLable:true,
  DepositedAmt:'',
  Reason:'',
  HubName:'',
  Bankname:'',
  Branchname:'',
  ID:'',
  IFSCcode:'',
  DepositSlipImage:'',
  toBeVerified:'',
  hubOutstandingCashBalance:'',
  isExcess:0,
  imageLoader: false,
  totalftcCashCollected: 0,
  amountSettled: 0,
      clientname: null,
      companyNamelist: [],
      arrWayBillNumbers: [],
      mdlWayBillNumber: null,
      AssignedList: [],
      AssignedSR: null,
      filterAwbNumber: '',
      showDepositWaybill: false,
      depositDetailsArray: [],
      
      deliveryStartDate : null,
      deliveryEndDate : null,
      validDateRange1: null,
      deliveryStartDateError : '',
      deliveryEndDateError: '',
      selectedDeliveryStartDate: null,
      depositSlipToDisplay : '',
      disabledflag:false,
      validDateRangeFrom1:'',
      todaysDate1:'',


    }
  },
  computed: {

  },
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.defaultHubID = userdetail.hubID[0];
    this.isLoading = true;
    await Promise.all([
      this.fTCCashDepositListing(),
      this.gethubcashbalance(),
      this.getCompanyShortName(),
      this.getSRListing()

    ]);
    this.isLoading = false;
  },
  methods: {
    async gethubcashbalance(){
      try {
        this.isLoading = true;
        let data = await FTCservices.gethubcashdetails({hubid:this.defaultHubID});
        if(data.data.code == 200 ){
          this.hubOutstandingCashBalance = data.data.data.hubOutstandingCashBalance;
          this.isExcess = data.data.data.isExcess
          this.toBeVerified = data.data.data.toBeVerified;
          this.totalftcCashCollected = data.data.data.totalFtcCashCollected
          this.amountSettled = data.data.data.amountSettled
        }
        this.isLoading = false;
      } catch (err) {
        console.log(err)
        this.isLoading = false;
      }
    },
    // Common function to prepare input payload and validate dates
    async prepareInputPayload(flag) {
      let inputPayload = {
        "offset": this.offset,
        "limit": this.pageLimit,
        "hubid": this.defaultHubID,
      };
      if (this.cashDepositID) {
        inputPayload.depositid = this.cashDepositID;
      }
      if (this.depositSlipNumber) {
        inputPayload.depositslipno = this.depositSlipNumber;
      }
      if (this.depositFromDate && this.depositToDate) {
        const fromDate = new Date(this.depositFromDate);
        const toDate = new Date(this.depositToDate);
        const differenceInDays = (toDate - fromDate) / (1000 * 60 * 60 * 24);
        if (fromDate > toDate) {
          this.isLoading = false;
          this.$alert("From-Date Must be Less Than To-Date", "FTC Finance Cash Deposit", "error");
          return null;
        } else if (differenceInDays > 15) {
          this.isLoading = false;
          this.$alert("Deposit date range should be less than 15 days", "FTC Finance Cash Deposit", "error");
          return null;
        }
      }
      if (this.depositToDate && !this.depositFromDate) {
        this.isLoading = false;
        this.$alert("Please select to-date", "FTC Finance Cash Deposit", "error");
        return null;
      }
      // Add date fields if they exist
      if (this.depositFromDate) {
        inputPayload.depositdatefrom = moment(this.depositFromDate).format('YYYY-MM-DD');
      }
      if (this.depositToDate) {
        inputPayload.depositdateto = moment(this.depositToDate).format('YYYY-MM-DD');
      }
      // Additional filters
      if (this.viewtransaction) inputPayload.viewtransaction = this.viewtransaction;
      if (this.depositStatus) inputPayload.depositstatus = this.depositStatus;
      if (this.clientname) inputPayload.clientname = this.clientname.id;
      if (this.AssignedSR) inputPayload.assignedsr = this.AssignedSR;
      if (this.filterAwbNumber) inputPayload.awbnumber = this.filterAwbNumber;
      if (flag) inputPayload.isexport = 1;
      return inputPayload;
    },

    async fTCCashDepositListing(flag){
      try {
        this.isLoading=true
        const inputPayload = await this.prepareInputPayload(flag); 
        if (!inputPayload) return;
        let result = await FTCservices.ftcCashDepositListing(inputPayload)
        if(result.data.code == 200){
          this.tableArr = result.data.data.rows;
          this.totalCount = result.data.data.count;
          let tempdata = result.data.data.rows.map((el) => {
            el.depositsstatus=el.depositsstatus=='0'?'To be verified':el.depositsstatus=='1'?'Accepted':el.depositsstatus=='2'?'Rejected':el.depositsstatus
            const flatAwbs = el.awb ? el.awb.reduce((acc, obj) => acc.concat(obj.awb), []) : ['NA']
            let responseObj = {
              'id': el.id,
              'Cash Deposit ID': el.depositid,
              "WayBill No":flatAwbs,
              'Amount deposited(INR)': el.depositamount,
              'Deposit Slip Number':el.depositslipno,
              'Deposit Date': Util.displayDateOnlyFormat(el.depositdate),
              'Created Date': Util.displayDateOnlyFormat(el.createddate),
              'Deposit by': el.depositby,
              'Deposit Status': el.depositsstatus,
              'awbDetails' : el.awb
            };
            if (!flag) {
              responseObj['Action'] = 'click OnEvent';
            }
            return responseObj;
          });
          if(flag){this.isLoading=false;return tempdata;}
          this.tableItems = []
          this.tableItems = tempdata
          // this.expandableKey += 1
        }else{
          this.totalCount = 0
          this.tableItems = [];
        }
        if (this.totalCount < this.pageLimit) {
          this.totalPage = 1
        } else {
          this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
        }
        this.isLoading = false
      }
      catch(err){
        this.isLoading = false
        console.log(err)
      }
    },

    searchFtcDeposit(){
      this.currentPage = 1;
      this.offset = 0;
      this.fTCCashDepositListing();
    },
    resetFilter(){
      this.currentPage = 1;
      this.offset = 0;
      this.cashDepositID = '',
      this.cashDepositIDSHow = '';
      this.depositSlipNumber='',
      this.depositFromDate='',
      this.depositToDate='',
      this.viewtransaction=null,
        this.depositStatus = null,
        this.clientname = null,
        this.AssignedSR = null,
        this.filterAwbNumber = null
      // this.onPageChange(1)
      this.fTCCashDepositListing()
    },
    callParent() {
        this.createFTCCashDeposit = false;
        this.fTCCashDepositListing();
        this.gethubcashbalance();
        this.showLable = true;
      },
      showFTCCashDeposit() {
        this.createFTCCashDeposit = true;
        this.showLable = false;
    },
    onPageChange(page){
      this.currentPage = page;
      this.offset = (page - 1) * this.pageLimit
      this.fTCCashDepositListing();
    },
    async exportSlips(){
      this.isLoading=true
      let flag = 1
      const inputPayload = await this.prepareInputPayload(flag); // Pass 1 for export flag
      if (!inputPayload) return;
      // Initialize an empty array to store the formatted data
      let tempData = [];
      let mergeRanges = []; // Array to keep track of merge ranges
      let result = await FTCservices.ftcCashDepositListing(inputPayload);
      if (result.data.code == 200) {
        this.tableArr = result.data.data.rows;
        this.totalCount = result.data.data.count;
        // Iterate over each row in the result data
        for (const el of result.data.data.rows) {
          // Map deposit status to corresponding text
          el.depositsstatus = el.depositsstatus == '0' ? 'To be verified' :
                              el.depositsstatus == '1' ? 'Accepted' :
                              el.depositsstatus == '2' ? 'Rejected' :
                              el.depositsstatus;
          // Extract waybill numbers from the fetched details
         let wayBillNumbers = el.awb ? el.awb.reduce((acc, obj) => acc.concat(obj.awb), []) : ['NA']
         let ftcamount = el.awb ? el.awb.map(item => parseFloat(item.ftcamount)).reduce((total, amount) => total + amount, 0):0
         const startRowIndex = tempData.length + 1; // Start index for merges
          // Create rows for each waybill
          if(el.awb){
            el.awb.forEach((item, index) => {
              let tdsamount = item.tdsamount ? item.tdsamount : 0
              // Construct the response object
              let responseObj = {
                'id': index === 0 ? el.id : '',
                'Cash Deposit ID': index === 0 ? el.depositid : '',
                'WayBill No': item.awb,
                'FTC Amount (INR)': item.amountwogst ? this.calculatePercent(item.amountwogst,18) : '',
                "TDS Amount (INR)": item.tdsamount ? item.tdsamount : '',
                "Net Collected Amount (INR)": item.ftcamount,
                'Amount deposited(INR)': el.depositamount,
                'Deposit Slip Number': index === 0 ? el.depositslipno : '',
                'Delivery Date and Time':item.deliverydatetime,
                'Deposit Date': index === 0 ? Util.displayDateOnlyFormat(el.depositdate) : '',
                'Deposit by': index === 0 ? el.depositby : '',
                "Deposit Creation Date": index === 0 ? Util.displayDateOnlyFormat(el.createddate) : '', 
                'Finance Verification Date': index === 0  && el.depositsstatus == 'Accepted' || el.depositsstatus == 'Rejected' ? Util.displayDateOnlyFormat(el.lastmodifieddate) : '',
                'Deposit Status': index === 0 ? el.depositsstatus : '',
              };
              // Add 'Action' field if condition is met, only on the first row
              if (!flag && index === 0) {
                responseObj['Action'] = 'click OnEvent';
              }
              // Push the constructed object to the tempData array
              tempData.push(responseObj);
            });
          }else{
            let responseObj = {
              'id':  el.id ,
              'Cash Deposit ID':el.depositid ,
              'WayBill No': 'NA',
              'FTC Amount (INR)': '',
              "TDS Amount (INR)":  '',
              "Net Collected Amount (INR)": '',
              'Amount deposited(INR)': el.depositamount,
              'Deposit Slip Number':  el.depositslipno ,
              'Delivery Date and Time': '',
              'Deposit Date':  Util.displayDateOnlyFormat(el.depositdate),
              'Deposit by':  el.depositby ,
              "Deposit Creation Date":  Util.displayDateOnlyFormat(el.createddate), 
              'Finance Verification Date': el.depositsstatus == 'Accepted' || el.depositsstatus == 'Rejected' ? Util.displayDateOnlyFormat(el.lastmodifieddate) : '',
              'Deposit Status':  el.depositsstatus,
            };
            tempData.push(responseObj);
          }
          if (wayBillNumbers.length > 1) {
            // Merge cells from start to end row
            mergeRanges.push({ s: { r: startRowIndex, c: 0 }, e: { r: startRowIndex + wayBillNumbers.length - 1, c: 0 } });
            mergeRanges.push({ s: { r: startRowIndex, c: 1 }, e: { r: startRowIndex + wayBillNumbers.length - 1, c: 1 } }); 
            mergeRanges.push({ s: { r: startRowIndex, c: 6 }, e: { r: startRowIndex + wayBillNumbers.length - 1, c: 6 } }); 
            mergeRanges.push({ s: { r: startRowIndex, c: 7 }, e: { r: startRowIndex + wayBillNumbers.length - 1, c: 7 } }); 
            mergeRanges.push({ s: { r: startRowIndex, c: 8 }, e: { r: startRowIndex + wayBillNumbers.length - 1, c: 8 } }); 
            mergeRanges.push({ s: { r: startRowIndex, c: 9 }, e: { r: startRowIndex + wayBillNumbers.length - 1, c: 9 } }); 
            mergeRanges.push({ s: { r: startRowIndex, c: 10 }, e: { r: startRowIndex + wayBillNumbers.length - 1, c: 10 } }); 
            mergeRanges.push({ s: { r: startRowIndex, c: 11 }, e: { r: startRowIndex + wayBillNumbers.length - 1, c: 11 } }); 
            mergeRanges.push({ s: { r: startRowIndex, c: 12 }, e: { r: startRowIndex + wayBillNumbers.length - 1, c: 12 } }); 
            mergeRanges.push({ s: { r: startRowIndex, c: 13 }, e: { r: startRowIndex + wayBillNumbers.length - 1, c: 13 } }); 
          }
        }
      }
      let dt = moment().tz('Asia/Kolkata').format('YYYYMMDDHHmmss');      const wb = XLSX.utils.book_new();
      const data = XLSX.utils.json_to_sheet(tempData);
      // Apply the merge ranges to the worksheet
      data['!merges'] = mergeRanges;
      XLSX.utils.book_append_sheet(wb, data, 'data')
      XLSX.writeFile(wb,dt+'depositslips.xlsx');
      this.isLoading=false
    },
    calculatePercent(value,percent){
      let gst =  Number(Number((value/100)*percent).toFixed(2)) ;
      return Math.round(Number(Number(value) + Number(gst)))
    },
    showDepositSlip(){
      this.viewDepositSlip = true;
      let image = document.getElementById('image');
      this.imageLoader = true;
      if(image.complete){
        this.imageLoader = false;
      }else{
        image.onload = () => {
          this.imageLoader = false;
        };
        image.onerror = () => {
          this.imageLoader = false;
        }
      }
    },
    async getCustomTableEvent(event) {
      var item = this.tableItems.find(item => item.id === event.id);
      this.depositSlipToDisplay = item['Cash Deposit ID']
      if (event.actionType == 'view') {
        this.isLoading=true
        this.ID = event.id
        this.showImgDownloadBtn=false
        let input = {
          id: this.ID,
        }
        let response = await FTCservices.ViewHubCashDepositSlip(input)
        if(response.data.code == 200){
          this.cashDepositIDSHow = response.data.data.depositid;
          this.DepositedAmt = response.data.data.depositamount;
          this.Reason = response.data.data.rejectreason;
          this.Bankname = response.data.data.bankname;
          this.Branchname = response.data.data.branchname;
          this.IFSCcode = response.data.data.ifsccode;
          this.DepositSlipImage = response.data.data.depositslipimage;
        }
        else{
          alert(response.message)
        }
        if(this.DepositSlipImage){
          document.getElementById('image').src = this.DepositSlipImage;
        }
        else
        document.getElementById('image').src = '';
        this.isLoading=false
      }
      if (event.actionType == "viewWaybill") {
        this.depositDetailsArray = item.awbDetails;
        this.showDepositWaybill = true;
    }
    },
    imgPlaceholder(e){
      this.showImgDownloadBtn=true;
    },
    async DownloadDepositSlip () {
      try {
        let input = {
          id: this.ID,
        }
        let response = await FTCservices.ViewHubCashDepositSlip(input);
        this.depositSlipImageDownload=response.data.data.depositslipimage;  
        if(response.status = 200){ 
          if (this.depositSlipImageDownload != null && !this.showImgDownloadBtn) {
          var link = document.createElement('a');
          link.setAttribute('href', this.depositSlipImageDownload);
          var fileName = this.depositSlipImageDownload.split('/').pop();
          link.setAttribute('download', fileName);
          link.click();
          } else{  
          this.$alert("Image not present");
          }
        }else{
          this.$alert("Image not present");
          }
      }catch(err) {
        console.log(err.message);
      }
    },
    badgetVarientChanger() {      
      if (this.isExcess == 1) {
         return("danger")
      } else {
        return("success")
      } 
    },
    // fetch client name for filter
    async getCompanyShortName() {
      try {        
        var CompanyShortList = [];
        let result = await FTCservices.getActiveInactiveClientList()
        CompanyShortList = result.data.data;
        for (var i = 0; i < CompanyShortList.length; i++) {
          this.companyNamelist.push({
            'id': CompanyShortList[i].ClientMasterID,
            'label': CompanyShortList[i].ClientShortName,
            'CompanyName': CompanyShortList[i].CompanyName
          })
        }
      } catch (err) {
        console.log(err);
      }
    },
    //fetch way bill details for filter
    async fetchWayBillNumbers(){
      try {        
       this.isLoading = true;
       let wayBillDetails = await FTCservices.fetchWayBillNumbers({hubid:this.defaultHubID});
       if (wayBillDetails.data.code == 200) {
         if(wayBillDetails.data.data && wayBillDetails.data.data.length > 0)
           this.arrWayBillNumbers = wayBillDetails.data.data.map(val => {
             return { id: val.awb, waybillNumber: val.awb, ftcAmount:val.ftcamount }            
           })
       }
       this.isLoading = false;
     } catch (err) {
       console.log(err)
       this.isLoading = false;
     }
    },
    //BA/ SR list
    async getSRListing() {
      try {
        let InputPayload = {
          HubId: [this.defaultHubID]
        };
        let result = await FTCservices.getSRList(InputPayload);
        let SRList = result.data.data;
        for (var i = 0; i < SRList.length; i++) {
          this.AssignedList.push({
            'id': SRList[i].userid,
            'label': SRList[i].srname + ' - '+ SRList[i].emptype +" " + '('+ SRList[i].userid + ')',
            'sremail': SRList[i].email,
            'olddelveryuseroruserid':SRList[i].olddelveryuseroruserid
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    checkStartDate() {
      // this.selectedDeliveryDate = moment().subtract(4, 'days').format('YYYY-MM-DD').valueOf();
      this.selectedDeliveryDate = moment(this.selectedDeliveryStartDate).add(14, 'days').format('YYYY-MM-DD').valueOf();
      this.validDateRangeFrom1 = moment.utc(this.depositToDate).format("YYYY-MM-DD").valueOf();

      if (this.depositToDate > this.selectedDeliveryDate) {
          this.$alertify.error("Please select date range should be less than or equal to 15 Days")
          this.depositToDate = null;
      }
      if (this.depositToDate != null) { this.deliveryEndDateError = false }
      if (this.depositToDate > this.todaysDate1) {
          this.$alertify.error("Please select today's date")
          this.depositToDate = null;
      }
  },
  checkEndDate() {
    this.depositToDate = null;
    this.todaysDate1 = moment().format('YYYY-MM-DD');
    this.selectedDeliveryStartDate = moment.utc(this.depositFromDate).format("YYYY-MM-DD").valueOf();
    this.selectedDeliveryDate = moment(this.selectedDeliveryStartDate).add(14, 'days').format('YYYY-MM-DD').valueOf();

    if (this.selectedDeliveryStartDate <= this.todaysDate1 && this.selectedDeliveryStartDate <= this.selectedDeliveryDate) {
        this.validDateRange1 = this.selectedDeliveryDate
        this.deliveryStartDateError = false
    } else {
        this.validDateRange1 = this.todaysDate1
        this.deliveryStartDateError = false
    }
    if (this.depositFromDate != null) { this.deliveryStartDateError = false }
},
    checkToDate() {
      this.dtpToDate = null;
      this.todaysDate = moment().format('YYYY-MM-DD');
      this.selectedDtpFromDate = moment.utc(this.dtpFromDate).format("YYYY-MM-DD").valueOf();
      if (this.selectedDtpFromDate >= this.todaysDate) {
          this.validDateRange = this.todaysDate
      } else {
          this.validDateRange = this.selectedDtpFromDate
      }
  },
  checkFromDate() {
      this.validDateRangeFrom = moment.utc(this.dtpToDate).format("YYYY-MM-DD").valueOf();
      if (this.dtpToDate > this.todaysDate) {
          this.$alertify.error("Please select less than todays date")
          this.dtpToDate = null;
      }
  },

  },

}



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/FTCHubCashDeposit/FTCHubCashDepositListing/FTCHubCashDepositListing.component.js